import clsx from 'clsx';
import styles from './StatusPill.module.css';

const LABEL_BY_KIND = {
  pending: 'Pending',
  attention: 'Attention',
  done: 'Done',
  exported: 'Exported',
  error: 'Error',
  skipped: 'Skipped',
  tagging: 'Tagging',
};

/**
 * Tank Redesign StatusPill — six-state status indicator.
 *
 * Source: ~/Downloads/tank-redesign/tokens.jsx → `StatusPill` function.
 * Six allowed kinds: pending / attention / done / exported / error / skipped.
 * Each renders a colored dot + label, consuming `--rd-status-<kind>-{fg,bg,line}`.
 *
 * Compact mode (used in dense grids) shrinks dot + label by ~1px each.
 *
 * @param {Object} props
 * @param {'pending'|'attention'|'done'|'exported'|'error'|'skipped'} props.kind
 * @param {boolean} [props.compact]
 * @param {React.ReactNode} [props.children] - override label (defaults to kind label)
 * @param {string} [props.className]
 */
export default function StatusPill({ kind, compact = false, children, className, ...rest }) {
  const label = children ?? LABEL_BY_KIND[kind];
  if (!label) return null;
  return (
    <span
      className={clsx(styles.pill, styles[kind], compact && styles.compact, className)}
      role="status"
      {...rest}
    >
      <span className={styles.dot} aria-hidden="true" />
      {label}
    </span>
  );
}
